export const RESET = 'CONDITION_LIST_RESET'
export const SET_ITEMS = 'CONDITION_LIST_SET_ITEMS'
export const SET_ERROR = 'CONDITION_LIST_SET_ERROR'
export const SET_VIEW = 'CONDITION_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'CONDITION_LIST_TOGGLE_LOADING'
